// Japam Sevak Chat Integration
(function() {
  // Add CSS styles to the page
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    #japam-sevak-modal {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 9999;
    }
    
    #japam-sevak-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #e5e7eb;
      overflow: hidden;
    }
    
    @media (min-width: 768px) {
      #japam-sevak-content {
        top: 10%;
        left: auto;
        right: 30px;
        transform: none;
        width: 100%;
        max-width: 400px;
        height: 80%;
        border-radius: 8px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      }
    }
    
    #japam-sevak-close {
      position: absolute;
      top: 15px;
      right: 10px;
      width: 30px;
      height: 30px;
      background-color: #0f172a;
      color: #ccc;
      border: none;
      border-radius: 50%;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    #japam-sevak-close svg {
      width: 24px;
      height: 24px;
      stroke: #ccc;
    }
    
    #japam-sevak-prompt {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      text-align: center;
      padding: 20px;
    }
    
    #japam-sevak-icon {
      width: 80px;
      height: 80px;
      background-color: #f5f5f5;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
    }
    
    #japam-sevak-icon svg {
      width: 50px;
      height: 50px;
      stroke: #c43f3f;
    }
    
    #japam-sevak-start {
      background-color: #c43f3f;
      color: white;
      border: none;
      padding: 15px 30px;
      font-size: 16px;
      border-radius: 4px;
      cursor: pointer;
      margin-top: 20px;
      transition: background-color 0.2s;
    }
    
    #japam-sevak-start:hover {
      background-color: #a83434;
    }
    
    #japam-sevak-iframe {
      width: 100%;
      height: 100%;
      border: none;
      display: none;
    }
  `;
  document.head.appendChild(styleElement);
  
  // Create the modal elements
  const modal = document.createElement('div');
  modal.id = 'japam-sevak-modal';
  modal.innerHTML = `
    <div id="japam-sevak-content">
      <button id="japam-sevak-close">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      
      <div id="japam-sevak-prompt">
        <div id="japam-sevak-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </div>
        <h3 style="font-size: 20px; margin: 0 0 10px 0;">Japam Sevak</h3>
        <p style="margin: 0 0 20px 0; color: #666;">Chat with Sevak for tracking, order help, product information, and more.</p>
        <button id="japam-sevak-start">Chat with Japam Sevak</button>
      </div>
      
      <iframe id="japam-sevak-iframe" src="about:blank" frameborder="0"></iframe>
    </div>
  `;
  document.body.appendChild(modal);
  
  // Get references to elements
  const closeBtn = document.getElementById('japam-sevak-close');
  const startBtn = document.getElementById('japam-sevak-start');
  const prompt = document.getElementById('japam-sevak-prompt');
  const iframe = document.getElementById('japam-sevak-iframe');
  
  // Function to open the modal with prompt
  function openSevakModal() {
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    
    // Reset to show prompt
    prompt.style.display = 'flex';
    iframe.style.display = 'none';
    iframe.src = 'about:blank';
  }
  
  // Function to start chat (load iframe)
  function startSevakChat() {
    // Hide prompt
    prompt.style.display = 'none';
    
    // Show and load iframe
    iframe.style.display = 'block';
    
    // Add timestamp to prevent caching
    const timestamp = new Date().getTime();
    iframe.src = `https://jackend.japam.in/sevak/index.html`;
  }
  
  // Function to close the modal
  function closeSevakModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
  }
  
  // Start button event
  startBtn.addEventListener('click', startSevakChat);
  
  // Close button event
  closeBtn.addEventListener('click', closeSevakModal);
  
  // Close on outside click
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeSevakModal();
    }
  });
  
  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      closeSevakModal();
    }
  });
  
  // Add event listeners to open buttons
  function attachOpenEventToButtons() {
    const openButtons = document.querySelectorAll('.open-sevak');
    openButtons.forEach(button => {
      if (!button.hasAttribute('data-sevak-initialized')) {
        button.setAttribute('data-sevak-initialized', 'true');
        button.addEventListener('click', function(e) {
          e.preventDefault();
          openSevakModal();
        });
      }
    });
  }
  
  // Initial attachment
  attachOpenEventToButtons();
  
  // Watch for new buttons
  const observer = new MutationObserver(attachOpenEventToButtons);
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Expose open function globally
  window.openJapamSevak = openSevakModal;
})();